export enum EPaymentTrackerAmenitiesPayor {
  HOMEROOM = 'homeroom',
  HOME_OWNER = 'home-owner'
}
